// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-wrapper {
  width: 100vw;
  padding-top: 15px;
  padding-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/charts/Revenue.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;AACF","sourcesContent":[".charts-wrapper {\n  width: 100vw;\n  padding-top: 15px;\n  padding-right: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
